import { Component, Input } from '@angular/core';
import { ClientPrescriberTask } from '../../../core/models/client-prescriber-task.model';
import { DatePipe } from '@angular/common';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
import { TaskEstimatedValueComponent } from '../../../shared/components/task-estimated-value/task-estimated-value.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { PatientAlternateNamesComponent } from '../../../shared/components/patient-alternate-names/patient-alternate-names.component';

@Component({
    selector: 'app-client-prescriber-task-header',
    templateUrl: './client-prescriber-task-header.component.html',
    imports: [UserPresenceComponent, TaskEstimatedValueComponent, DatePipe, BlankValueDashPipe,
              PatientAlternateNamesComponent]
})
export class ClientPrescriberTaskHeaderComponent {
  @Input() task: ClientPrescriberTask;
  @Input() displayUserPresence = true;

  constructor() {}
}
